import deepEqual from 'lodash/fp/isEqual';

export function deepEquals<A>(
  left: undefined | A,
  right: undefined | A,
): boolean {
  return deepEqual(left, right);
}
